import { useEffect } from "react";
import { useRawTable } from "../../hooks";

export default function Module_BoneMuscleCare_AILevel({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const { setTbData, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;
    setTbData({
      raw: apiData,
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
